import DealModal from "./DealModal";

export default DealModal;
